<template>
  <div>    
    <div :id="navigation.mapID" :style="`width: ${width}; height: ${height}`"></div>
    <v-dialog v-model="navigation.createDivisionDialogIsVisible" max-width="400px">
      <v-card max-width="400px" style="padding: 15px;">
        <v-text-field 
          v-model="input.mapDivisionName" 
          label="Nombre de la división"
          ref="mapDivisionName"
          @click:append-inner="$generalFunctions.default.blurInput(this, 'mapDivisionName'); input.mapDivisionName = null;"
          :append-inner-icon="input.mapDivisionName ? 'mdi-alphabetical-variant-off' : 'mdi-alphabetical-variant'"
          density="compact"
          variant="solo-filled"
        ></v-text-field>
        <v-textarea
          v-model="input.mapDivisionDescription"
          label="Descripción de la división (opcional)"
          ref="mapDivisionDescription"
          @click:append-inner="$generalFunctions.default.blurInput(this, 'mapDivisionDescription'); input.mapDivisionDescription = null;"
          :append-inner-icon="input.mapDivisionDescription ? 'mdi-alphabetical-off' : 'mdi-alphabetical'"
          rows="3"
          density="compact"
          variant="solo-filled"
        ></v-textarea>
        <v-text-field 
            ref="mapDivisionColor"
            @click="navigation.mapDivisionColorDialogIsVisible = true" 
            @click:append-inner="$generalFunctions.default.blurInput(this, 'mapDivisionColor'); input.mapDivisionColor = '#00000000';"
            :append-inner-icon="input.mapDivisionColor == '#00000000' ? 'mdi-palette' : 'mdi-palette-outline'"
            v-model="input.mapDivisionColor" 
            :bg-color="input.mapDivisionColor" 
            readonly="true" 
            label="Color de la división" 
            variant="solo-filled"
            density="compact"
        ></v-text-field>
        <v-dialog v-model="navigation.mapDivisionColorDialogIsVisible" width="auto">
          <v-card width="300">
            <v-color-picker v-model="input.mapDivisionColor" :modes="['hex']" show-swatches></v-color-picker>
          </v-card>
        </v-dialog>
        <br>
        <v-tooltip :disabled="validateDivisionInput(false).success" location="top"> 
          <template v-slot:activator="{ props }">
            <div v-bind="props">
              <v-btn @click="createDivision()" :disabled="!validateDivisionInput(false).success" color="success" dark block height="38" style="margin-bottom: 10px;">
                <h3>AGREGAR DIVISIÓN</h3>
                <v-icon style="margin-left: 10px;" dark right>mdi-plus-circle-outline</v-icon>
              </v-btn>
            </div>
          </template>
          <span style="max-width: 400px; display: block;">{{ validateDivisionInput(false).result }}</span>
        </v-tooltip>
        <v-btn @click="navigation.createDivisionDialogIsVisible = false" color="error" dark block height="38">
          <h3>CANCELAR</h3>
          <v-icon style="margin-left:10px;" dark right>mdi-close-circle-outline</v-icon>
        </v-btn>
      </v-card>
    </v-dialog>

    <v-dialog v-model="navigation.updateDivisionDialogIsVisible" max-width="500px">
      <v-card max-width="400px" style="padding: 15px;">
        <v-text-field
          v-model="input.mapDivisionName"
          label="Nombre de la división"
          ref="editMapDivisionName"
          @click:append-inner="$generalFunctions.default.blurInput(this, 'editMapDivisionName'); input.mapDivisionName = null;"
          :append-inner-icon="input.mapDivisionName ? 'mdi-alphabetical-variant-off' : 'mdi-alphabetical-variant'"
          density="compact"
          variant="solo-filled"
        ></v-text-field>
        <v-textarea
          v-model="input.mapDivisionDescription"
          label="Descripción de la división (opcional)"
          ref="editMapDivisionDescription"
          @click:append-inner="$generalFunctions.default.blurInput(this, 'editMapDivisionDescription'); input.mapDivisionDescription = null;"
          :append-inner-icon="input.mapDivisionDescription ? 'mdi-alphabetical-off' : 'mdi-alphabetical'"
          rows="3"
          density="compact"
          variant="solo-filled"
        ></v-textarea>
        <v-text-field 
          ref="editMapDivisionColor"
          @click="navigation.mapDivisionColorDialogIsVisible = true" 
          @click:append-inner="$generalFunctions.default.blurInput(this, 'editMapDivisionColor'); input.mapDivisionColor = '#00000000';"
          :append-inner-icon="input.mapDivisionColor == '#00000000' ? 'mdi-palette' : 'mdi-palette-outline'"
          v-model="input.mapDivisionColor"
          :bg-color="input.mapDivisionColor"
          readonly="true"
          label="Color de la división"
          variant="solo-filled"
          density="compact"
        ></v-text-field>
        <v-dialog v-model="navigation.mapDivisionColorDialogIsVisible" width="auto">
          <v-card width="300">
            <v-color-picker v-model="input.mapDivisionColor" :modes="['hex']" show-swatches></v-color-picker>
          </v-card>
        </v-dialog>
        <br>
        <v-tooltip :disabled="validateDivisionInput(false).success" location="top"> 
          <template v-slot:activator="{ props }">
            <div v-bind="props">
              <v-btn @click="updateDivision()" :disabled="!validateDivisionInput(false).success" color="success" dark block height="38" style="margin-bottom: 10px;">
                <h3>ACTUALIZAR DIVISIÓN</h3>
                <v-icon style="margin-left: 10px;" dark right>mdi-update</v-icon>
              </v-btn>
            </div>
          </template>
          <span style="max-width: 400px; display: block;">{{ validateDivisionInput(false).result }}</span>
        </v-tooltip>
        <v-btn @click="deleteDivision()" color="error" dark block height="38" style="margin-bottom: 10px;">
          <h3>ELIMINAR DIVISIÓN</h3>
          <v-icon style="margin-left: 10px;" dark right>mdi-delete-circle-outline</v-icon>
        </v-btn>
        <v-btn @click="navigation.updateDivisionDialogIsVisible = false" color="info" dark block height="38">
          <h3>CANCELAR</h3>
          <v-icon style="margin-left:10px;" dark right>mdi-close-circle-outline</v-icon>
        </v-btn>
      </v-card>
    </v-dialog>

  </div>
</template>

<style scoped>
</style>

<script>
  import { Map, View } from 'ol';
  import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer';
  import { OSM, Vector as VectorSource } from 'ol/source';
  import { fromLonLat, transform } from "ol/proj";
  import { FullScreen } from 'ol/control.js';
  import { Style, Fill, Stroke, Text } from 'ol/style';
  import { Modify } from 'ol/interaction';
  import { Feature } from 'ol';
  import { Point, Polygon, LineString } from 'ol/geom';
  import { Circle as CircleStyle, Icon } from 'ol/style';
  import polyline from '@mapbox/polyline';

  export default {

    inject: ['$generalFunctions', '$displayFunctions'],

    props: 
    {
      width: {type: String, default: '600px'},
      height: {type: String, default: '600px'},

      creationMap: {type: Boolean, default: false},
      creationMapPolygon: {type: Boolean, default: false},
      creationMapName: {type: String, default: ''},
      creationMapColor: {type: String, default: '#000000'},
      creationMapFontColor: {type: String, default: '#000000'},
      
      showMap: {type: Boolean, default: false},
      showMapName: {type: String, default: ''},
      showMapColor: {type: String, default: '#000000'},
      showMapFontColor: {type: String, default: '#000000'},
      showMapPoint: {type: Object, default: () => null},
      showMapPolygon: {type: Array, default: () => []},
      showMapDivisions: {type: Array, default: () => []},

      showPoint: {type: Boolean, default: false},
      showRoute: {type: Boolean, default: false},
      showPointDrawPoint: {type: Boolean, default: false},
      showPointPoint: {type: Object, default: () => null},
      showPointName: {type: String, default: ''},

      editMap: {type: Boolean, default: false},
      editMapName: {type: String, default: ''},
      editMapColor: {type: String, default: '#000000'},
      editMapFontColor: {type: String, default: '#000000'},
      editMapPoint: {type: Object, default: () => null},
      editMapPolygon: {type: Array, default: () => []},
      editMapDivisions: {type: Array, default: () => []},

      drawCRMWhatsappInvoiceByCRMLocalityMapDivision: {type: Boolean, default: false},

      displayMaps: {type: Array, default: () => []},
      date: {type: Array, default: () => []},
      CRMWhatsappInvoiceCRMLocalityID: {type: Array, default: () => []},
    },

    data: () => ({
      input: 
      {
        mapDivisionName: null,
        mapDivisionDescription: null,
        mapDivisionColor: '#00000000',
      },
      navigation: 
      {
        mapComponent: null,
        mapID: `map-${Math.random().toString(36).substring(2, 11)}`,
        mapMainPolygonVectorSource: null,
        mapMainPolygonVectorLayer: null,
        mapMainPointVectorSource: null,
        mapMainPointVectorLayer: null,
        
        previewPointVectorSource: null,
        previewPointVectorLayer: null,
        previewPolygonVectorSource: null,
        previewPolygonVectorLayer: null,
        
        divisionVectorSource: null,
        divisionVectorLayer: null,

        mapDisplayVectorSource: null,
        mapDisplayVectorLayer: null,

        routeVectorSource: null,
        routeVectorLayer: null,

        mapCreationHasPoint: false,
        mapCreationPolygonCoordinates: [],
        mapEditPolygonCoordinates: [],

        createDivisionDialogCoordinate: null,
        createDivisionDialogIsVisible: false,
        updateDivisionFeature: null,
        updateDivisionDialogIsVisible: false,
        mapDivisionColorDialogIsVisible: false
      }
    }),

    watch: {
      creationMapColor(creationMapNewColor) {
        if (this.navigation.mapMainPolygonVectorLayer){
          this.navigation.mapMainPolygonVectorLayer.setStyle(new Style({'fill': new Fill({'color': creationMapNewColor ? this.$generalFunctions.default.fromHexToRGBA(creationMapNewColor, 0.4) : 'rgba(0,0,0,0)'}), 'stroke': new Stroke({'color': '#000000', 'width': 1})}));
        }
        if (this.navigation.mapMainPointVectorLayer){
          this.navigation.mapMainPointVectorLayer.setStyle(new Style({'image': new CircleStyle({'radius': 8, 'fill': new Fill({'color': creationMapNewColor ? this.$generalFunctions.default.fromHexToRGBA(creationMapNewColor, 1) : '#ffffff'}), 'stroke': new Stroke({'color': '#000000', 'width': 2})}), 'text': new Text({'text': this.creationMapName, 'offsetY': -20, 'font': 'bold 15px Arial', 'stroke': new Stroke({'color': '#ffffff', 'width': 3})})}));
        }
        if (this.navigation.previewPointVectorLayer) {
          this.navigation.previewPointVectorLayer.setStyle(new Style({'image': new CircleStyle({'radius': 8, 'fill': new Fill({'color': creationMapNewColor ? this.$generalFunctions.default.fromHexToRGBA(creationMapNewColor, 0.5) : 'rgba(255,255,255,0.5)'}), 'stroke': new Stroke({'color': '#000000', 'width': 2})}), 'text': new Text({'text': this.creationMapName, 'offsetY': -20, 'font': 'bold 15px Arial', 'stroke': new Stroke({'color': '#ffffff', 'width': 3})})}));
        }
        if (this.navigation.previewPolygonVectorLayer) {
          this.navigation.previewPolygonVectorLayer.setStyle(new Style({'fill': new Fill({'color': creationMapNewColor ? this.$generalFunctions.default.fromHexToRGBA(creationMapNewColor, 0.2) : 'rgba(0,0,0,0.2)'}), 'stroke': new Stroke({'color': '#000000', 'width': 2})}));
        }
      },
      creationMapFontColor(creationMapNewFontColor) {
        if (this.navigation.mapMainPointVectorLayer){
          this.navigation.mapMainPointVectorLayer.setStyle(new Style({'image': new CircleStyle({'radius': 8, 'fill': new Fill({'color': this.creationMapColor ? this.$generalFunctions.default.fromHexToRGBA(this.creationMapColor, 1) : '#ffffff'}), 'stroke': new Stroke({'color': '#000000', 'width': 2})}), 'text': new Text({'text': this.creationMapName, 'offsetY': -20, 'font': 'bold 15px Arial', 'fill': new Fill({'color': creationMapNewFontColor || '#000000'}), 'stroke': new Stroke({'color': '#ffffff', 'width': 3})})}));
        }
        if (this.navigation.previewPointVectorLayer) {
          this.navigation.previewPointVectorLayer.setStyle(new Style({'image': new CircleStyle({'radius': 8, 'fill': new Fill({'color': this.creationMapColor ? this.$generalFunctions.default.fromHexToRGBA(this.creationMapColor, 0.5) : 'rgba(255,255,255,0.5)'}), 'stroke': new Stroke({'color': '#000000', 'width': 2})}), 'text': new Text({'text': this.creationMapName, 'offsetY': -20, 'font': 'bold 15px Arial', 'fill': new Fill({'color': creationMapNewFontColor || '#000000'}), 'stroke': new Stroke({'color': '#ffffff', 'width': 3})})}));
        }
      },
      creationMapName(creationMapNewName) {
        if (this.navigation.mapMainPointVectorLayer) {
          this.navigation.mapMainPointVectorLayer.setStyle(new Style({'image': new CircleStyle({'radius': 8, 'fill': new Fill({'color': this.creationMapColor ? this.$generalFunctions.default.fromHexToRGBA(this.creationMapColor, 1) : '#ffffff'}), 'stroke': new Stroke({'color': '#000000', 'width': 2})}), 'text': new Text({'text': creationMapNewName, 'offsetY': -20, 'font': 'bold 15px Arial', 'stroke': new Stroke({'color': '#ffffff', 'width': 3})})}));
        }
        if (this.navigation.previewPointVectorLayer) {
          this.navigation.previewPointVectorLayer.setStyle(new Style({'image': new CircleStyle({'radius': 8, 'fill': new Fill({'color': this.creationMapColor ? this.$generalFunctions.default.fromHexToRGBA(this.creationMapColor, 0.5) : 'rgba(255,255,255,0.5)'}), 'stroke': new Stroke({'color': '#000000', 'width': 2})}), 'text': new Text({'text': creationMapNewName, 'offsetY': -20, 'font': 'bold 15px Arial', 'stroke': new Stroke({'color': '#ffffff', 'width': 3})})}));
        }
      },
      'input.mapDivisionColor'() {
        if (this.input.mapDivisionColor != '#00000000'){
          this.input.mapDivisionColor = this.input.mapDivisionColor.substring(0, 7) + 'ff';
        }
      }
    },

    methods: {
      createMapMainComponent(){
        this.navigation.mapMainPolygonVectorSource = new VectorSource();
        this.navigation.mapDisplayVectorSource = new VectorSource();
        this.navigation.mapMainPointVectorSource = new VectorSource();
        this.navigation.previewPointVectorSource = new VectorSource();
        this.navigation.previewPolygonVectorSource = new VectorSource();
        this.navigation.mapMainPolygonVectorLayer = new VectorLayer({ 'source': this.navigation.mapMainPolygonVectorSource, 'style': new Style({ 'fill': new Fill({'color': this.creationMapColor ? this.$generalFunctions.default.fromHexToRGBA(this.creationMapColor, 0.4) : 'rgba(0,0,0,0)'}), 'stroke': new Stroke({'color': '#000000', 'width': 2}) }) });
        this.navigation.mapDisplayVectorLayer = new VectorLayer({ 'source': this.navigation.mapDisplayVectorSource, 'style': new Style({ 'fill': new Fill({'color': this.creationMapColor ? this.$generalFunctions.default.fromHexToRGBA(this.creationMapColor, 0.4) : 'rgba(0,0,0,0)'}), 'stroke': new Stroke({ 'color': '#000000', 'width': 2 }) }) });
        this.navigation.mapMainPointVectorLayer = new VectorLayer({ 'source': this.navigation.mapMainPointVectorSource, 'style': new Style({ 'image': new CircleStyle({ 'radius': 8, 'fill': new Fill({'color': this.creationMapColor ? this.$generalFunctions.default.fromHexToRGBA(this.creationMapColor, 1) : '#ffffff'}), 'stroke': new Stroke({ 'color': '#000000', 'width': 2 }) }), 'text': new Text({ 'text': this.creationMapName, 'offsetY': -20, 'font': 'bold 15px Arial', 'stroke': new Stroke({ 'color': '#ffffff', 'width': 3 }) }) }) });
        this.navigation.previewPointVectorLayer = new VectorLayer({ 'source': this.navigation.previewPointVectorSource, 'style': new Style({ 'image': new CircleStyle({ 'radius': 8, 'fill': new Fill({'color': this.creationMapColor ? this.$generalFunctions.default.fromHexToRGBA(this.creationMapColor, 0.5) : 'rgba(255,255,255,0.5)'}), 'stroke': new Stroke({ 'color': '#000000', 'width': 2 }) }), 'text': new Text({ 'text': this.creationMapName, 'offsetY': -20, 'font': 'bold 15px Arial', 'stroke': new Stroke({ 'color': '#ffffff', 'width': 3 }) }) }) });
        this.navigation.previewPolygonVectorLayer = new VectorLayer({ 'source': this.navigation.previewPolygonVectorSource, 'style': new Style({ 'fill': new Fill({'color': this.creationMapColor ? this.$generalFunctions.default.fromHexToRGBA(this.creationMapColor, 0.2) : 'rgba(0,0,0,0.2)'}), 'stroke': new Stroke({'color': '#000000', 'width': 2}) }) });
        this.navigation.divisionVectorSource = new VectorSource();
        this.navigation.divisionVectorLayer = new VectorLayer({ source: this.navigation.divisionVectorSource, style: new Style({ stroke: new Stroke({ color: '#383838', width: 2, lineDash: [5, 5] }), fill: new Fill({ color: 'rgba(0,0,0,0)' }), text: new Text({ font: 'bold 10px Arial', fill: new Fill({ color: '#383838' }), stroke: new Stroke({ color: '#fff', width: 3 }) }) }) });
        this.navigation.mapComponent = new Map({ controls: [new FullScreen()], target: this.navigation.mapID, layers: [new TileLayer({source: new OSM(), attributions: []}), this.navigation.mapMainPolygonVectorLayer, this.navigation.mapDisplayVectorLayer, this.navigation.mapMainPointVectorLayer, this.navigation.previewPointVectorLayer, this.navigation.previewPolygonVectorLayer, this.navigation.divisionVectorLayer], view: new View({ center: fromLonLat([-84.0585289, 9.9242503]), zoom: 13 }) });
        const divisionModifyInteraction = new Modify({ source: this.navigation.divisionVectorSource });
        this.navigation.mapComponent.addInteraction(divisionModifyInteraction);
        divisionModifyInteraction.on('modifystart', (event) => {
          if (event.features.getArray()[0] && event.features.getArray()[0].getGeometry()) event.features.getArray()[0].set('originalCoordinates', event.features.getArray()[0].getGeometry().getCoordinates());
        });
        divisionModifyInteraction.on('modifyend', (event) => {
          if (JSON.stringify(event.features.getArray()[0].get('originalCoordinates')) == JSON.stringify(event.features.getArray()[0].getGeometry().getCoordinates())) {
            event.features.getArray()[0].unset('originalCoordinates');
            return;
          }
          if (!this.navigation.mapMainPolygonVectorSource.getFeatures().find(mapMainPolygonVectorSourceFeature => mapMainPolygonVectorSourceFeature.getGeometry() instanceof Polygon)) return;
          for (const divisionVectorSourceFeature of this.navigation.divisionVectorSource.getFeatures()) {
            if (divisionVectorSourceFeature.get('id') == event.features.getArray()[0].get('id')){
              continue;
            }
          }
          event.features.getArray()[0].unset('originalCoordinates');
          this.emitDivisionsUpdate();
        });
      },

      createDisplayMaps(){
        this.displayMaps.forEach(displayMap => {
          const displayMapPointFeature = new Feature({'geometry': new Point(fromLonLat([displayMap.mapCenterLongitude, displayMap.mapCenterLatitude])), 'mapName': displayMap.mapName, 'mapID': displayMap.mapID}); 
          displayMapPointFeature.setStyle(new Style({'image': new CircleStyle({'radius': 8, 'fill': new Fill({'color': displayMap.mapColor ? this.$generalFunctions.default.fromHexToRGBA(displayMap.mapColor, 1) : '#ffffff'}), 'stroke': new Stroke({'color': '#000000', 'width': 2})}), 'text': new Text({'text': displayMap.mapName, 'offsetY': -20, 'font': 'bold 15px Arial', 'stroke': new Stroke({'color': '#ffffff', 'width': 3})})}));
          this.navigation.mapDisplayVectorSource.addFeature(displayMapPointFeature);
          const displayMapPolygonFeature = new Feature({'geometry': new Polygon([displayMap.mapPoints.map(mapPoint => fromLonLat([mapPoint.mapPointLongitude, mapPoint.mapPointLatitude]))])});
          displayMapPolygonFeature.setStyle(new Style({'fill': new Fill({'color': this.$generalFunctions.default.fromHexToRGBA(displayMap.mapColor, 0.4)}), 'stroke': new Stroke({'color': '#000000', 'width': 2})}));
          this.navigation.mapDisplayVectorSource.addFeature(displayMapPolygonFeature);

          displayMap.mapDivisions.sort((a, b) => {
            if (a.mapDivisionIsDisplayOnly !== b.mapDivisionIsDisplayOnly) return a.mapDivisionIsDisplayOnly - b.mapDivisionIsDisplayOnly;
            return a.mapDivisionID - b.mapDivisionID;
          });          
          displayMap.mapDivisions.forEach(mapDivision => {
            let mapDivisionText = `${mapDivision.mapDivisionName}${mapDivision.mapDivisionDescription ? `\n${mapDivision.mapDivisionDescription}` : ''}`;
            let mapDivisionTextFont = 'bold 10px Arial';
            if (mapDivision.mapDivisionIsDisplayOnly == false){
              if (this.drawCRMWhatsappInvoiceByCRMLocalityMapDivision) {
                mapDivision.CRMWhatsappInvoice = mapDivision.CRMWhatsappInvoice ? mapDivision.CRMWhatsappInvoice : {'CRMWhatsappInvoiceCount' : 0, 'CRMWhatsappInvoiceAmount': 0};
                mapDivisionText += `\n${mapDivision.CRMWhatsappInvoice.CRMWhatsappInvoiceCount} ${mapDivision.CRMWhatsappInvoice.CRMWhatsappInvoiceCount == 1 ? 'orden' : 'órdenes'} ${mapDivision.offsetCRMWhatsappInvoice && mapDivision.offsetCRMWhatsappInvoice.CRMWhatsappInvoiceCount > 0 ? `(${(mapDivision.CRMWhatsappInvoice.CRMWhatsappInvoiceAmount == mapDivision.offsetCRMWhatsappInvoice.CRMWhatsappInvoiceCount) ? '' : (mapDivision.CRMWhatsappInvoice.CRMWhatsappInvoiceCount > mapDivision.offsetCRMWhatsappInvoice.CRMWhatsappInvoiceCount ? '+' : '-')} ${this.$displayFunctions.default.parseAmountToDisplay(Math.abs((mapDivision.CRMWhatsappInvoice.CRMWhatsappInvoiceCount - mapDivision.offsetCRMWhatsappInvoice.CRMWhatsappInvoiceCount) / mapDivision.offsetCRMWhatsappInvoice.CRMWhatsappInvoiceCount) * 100)} %)` : ''}`;
                mapDivisionText += `\n ₡${this.$displayFunctions.default.parseAmountToDisplay(Math.round(mapDivision.CRMWhatsappInvoice.CRMWhatsappInvoiceAmount / 5) * 5)} ${mapDivision.offsetCRMWhatsappInvoice && mapDivision.offsetCRMWhatsappInvoice.CRMWhatsappInvoiceAmount > 0 ? `(${(mapDivision.CRMWhatsappInvoice.CRMWhatsappInvoiceAmount == mapDivision.offsetCRMWhatsappInvoice.CRMWhatsappInvoiceAmount) ? '' : (mapDivision.CRMWhatsappInvoice.CRMWhatsappInvoiceAmount > mapDivision.offsetCRMWhatsappInvoice.CRMWhatsappInvoiceAmount ? '+' : '-')} ${this.$displayFunctions.default.parseAmountToDisplay(Math.abs((mapDivision.CRMWhatsappInvoice.CRMWhatsappInvoiceAmount - mapDivision.offsetCRMWhatsappInvoice.CRMWhatsappInvoiceAmount) / mapDivision.offsetCRMWhatsappInvoice.CRMWhatsappInvoiceAmount) * 100)} %)` : ''}`;
                mapDivisionTextFont = 'bold 12px Arial';
              }
            }
            const mapDivisionFeature = new Feature({'geometry': new Polygon([mapDivision.mapDivisionPoints.map(mapDivisionPoint => fromLonLat([mapDivisionPoint.mapDivisionPointLongitude, mapDivisionPoint.mapDivisionPointLatitude]))]), 'mapDivisionID': mapDivision.mapDivisionID, 'name': mapDivision.mapDivisionName, 'description': mapDivision.mapDivisionDescription, 'color': mapDivision.mapDivisionColor, 'CRMWhatsappInvoice': mapDivision.CRMWhatsappInvoice});
            mapDivisionFeature.setStyle(new Style({'stroke': new Stroke({'color': '#383838', 'width': 2, 'lineDash': [5, 5]}), 'fill': new Fill({'color': mapDivision.mapDivisionColor ? this.$generalFunctions.default.fromHexToRGBA(mapDivision.mapDivisionColor, 0.2) : 'rgba(0,0,0,0)'}), 'text': new Text({'text': mapDivisionText, 'font': mapDivisionTextFont, 'fill': new Fill({'color': '#383838'}), 'stroke': new Stroke({'color': '#fff', 'width': 3})})}));
            this.navigation.mapDisplayVectorSource.addFeature(mapDivisionFeature);
          });
        });
      },

      drawShowMap(){
        if (!this.navigation.mapMainPointVectorSource || !this.showMapPoint || !this.showMapPoint.latitude || !this.showMapPoint.longitude) return;
        if (!this.navigation.mapMainPolygonVectorSource || !this.showMapPolygon || this.showMapPolygon.length == 0) return;
        this.navigation.mapMainPointVectorSource.clear();
        this.navigation.mapMainPolygonVectorSource.clear();
        this.navigation.mapMainPointVectorSource.addFeature(new Feature({'geometry': new Point(fromLonLat([this.showMapPoint.longitude, this.showMapPoint.latitude])), 'name': this.showMapName}));
        this.navigation.mapMainPointVectorLayer.setStyle(new Style({'image': new CircleStyle({'radius': 8, 'fill': new Fill({'color': this.showMapColor ? this.$generalFunctions.default.fromHexToRGBA(this.showMapColor, 0.5) : '#ffffff'}), 'stroke': new Stroke({'color': '#000000', 'width': 2})}), 'text': new Text({'text': this.showMapName, 'offsetY': -20, 'font': 'bold 15px Arial', 'stroke': new Stroke({'color': '#ffffff', 'width': 3})})}));
        this.navigation.mapComponent.getView().setCenter(fromLonLat([this.showMapPoint.longitude, this.showMapPoint.latitude]));
        this.navigation.mapMainPolygonVectorSource.addFeature(new Feature({'geometry': new Polygon([this.showMapPolygon.map(showMapPoint => fromLonLat([showMapPoint.longitude, showMapPoint.latitude]))])}));
        this.navigation.mapMainPolygonVectorLayer.setStyle(new Style({'fill': new Fill({'color': this.showMapColor ? this.$generalFunctions.default.fromHexToRGBA(this.showMapColor, 0.5) : 'rgba(0,0,0,0)'}), 'stroke': new Stroke({'color': '#000000', 'width': 2})}));
        this.navigation.mapComponent.getView().fit(this.navigation.mapMainPolygonVectorSource.getExtent(), {padding: [50, 50, 50, 50], maxZoom: 15});
        this.showMapDivisions.forEach(showMapDivision => {
          showMapDivision.mapDivisionPoints.map(mapDivisionPoint => fromLonLat([mapDivisionPoint.mapDivisionPointLongitude, mapDivisionPoint.mapDivisionPointLatitude])).push(showMapDivision.mapDivisionPoints.map(mapDivisionPoint => fromLonLat([mapDivisionPoint.mapDivisionPointLongitude, mapDivisionPoint.mapDivisionPointLatitude]))[0]);
          const showMapDivisionFeature = new Feature({'geometry': new Polygon([showMapDivision.mapDivisionPoints.map(mapDivisionPoint => fromLonLat([mapDivisionPoint.mapDivisionPointLongitude, mapDivisionPoint.mapDivisionPointLatitude]))])});
          showMapDivisionFeature.setStyle(new Style({'stroke': new Stroke({'color': '#383838', 'width': 2, 'lineDash': [5, 5]}), 'fill': new Fill({'color': showMapDivision.mapDivisionColor ? this.$generalFunctions.default.fromHexToRGBA(showMapDivision.mapDivisionColor, 0.01) : 'rgba(0,0,0,0)'}), 'text': new Text({'text': showMapDivision.mapDivisionName + (showMapDivision.mapDivisionDescription ? `\n${showMapDivision.mapDivisionDescription}` : ''), 'font': 'bold 10px Arial', 'fill': new Fill({'color': '#383838'}), 'stroke': new Stroke({'color': '#ffffff', 'width': 3})})}));
          this.navigation.mapDisplayVectorSource.addFeature(showMapDivisionFeature);
        });
      },

      async drawShowPoint(){
        if (!this.navigation.mapMainPointVectorSource || !this.showPointPoint || !this.showPointPoint.latitude || !this.showPointPoint.longitude) return;
        this.navigation.mapMainPointVectorSource.clear();
        this.navigation.mapMainPointVectorSource.addFeature(new Feature({'geometry': new Point(fromLonLat([this.showPointPoint.longitude, this.showPointPoint.latitude]))}));
        this.navigation.mapMainPointVectorLayer.setStyle(new Style({'image': new Icon({'src': 'https://maps.google.com/mapfiles/ms/icons/red-dot.png', 'scale': this.showPointDrawPoint ? 1 : 0, 'anchor': [0.5, 1]}), 'text': new Text({'text': this.showPointName, 'offsetY': -60, 'font': 'bold 15px Arial', 'fill': new Fill({'color': '#000000'}), 'stroke': new Stroke({'color': '#ffffff', 'width': 3})})}));
        this.navigation.mapComponent.getView().setCenter(fromLonLat([this.showPointPoint.longitude, this.showPointPoint.latitude]));
        this.navigation.mapComponent.getView().fit(this.navigation.mapMainPointVectorSource.getExtent(), {'padding': [50, 50, 50, 50], 'maxZoom': 15});
        let foundMap = null;
        let foundMapDivision = null;
        for (const displayMap of this.displayMaps) {
          const mapPolygon = new Polygon([displayMap.mapPoints.map(mapPoint => 
            fromLonLat([mapPoint.mapPointLongitude, mapPoint.mapPointLatitude])
          )]);
          if (mapPolygon.intersectsCoordinate(fromLonLat([this.showPointPoint.longitude, this.showPointPoint.latitude]))) {
            foundMap = displayMap;
            for (const mapDivision of displayMap.mapDivisions) {
              const divisionPolygon = new Polygon([mapDivision.mapDivisionPoints.map(mapDivisionPoint => 
                fromLonLat([mapDivisionPoint.mapDivisionPointLongitude, mapDivisionPoint.mapDivisionPointLatitude])
              )]);
              if (divisionPolygon.intersectsCoordinate(fromLonLat([this.showPointPoint.longitude, this.showPointPoint.latitude]))) {
                foundMapDivision = mapDivision;
                break;
              }
            }
            break;
          }
        }
        this.$emit('showPointLocationFound', {
          map: foundMap ? {
            mapID: foundMap.mapID,
            mapName: foundMap.mapName
          } : null,
          mapDivision: foundMapDivision ? {
            mapDivisionID: foundMapDivision.mapDivisionID,
            mapDivisionName: foundMapDivision.name
          } : null
        });
      },

      async drawShowRoute(){
        if (!this.navigation.mapMainPointVectorSource || !this.showPointPoint || !this.showPointPoint.latitude || !this.showPointPoint.longitude) return;
        let routeDistance = null;
        let trafficDuration = null;
        for (const displayMap of this.displayMaps) {        
          if (new Polygon([displayMap.mapPoints.map(mapPoint => fromLonLat([mapPoint.mapPointLongitude, mapPoint.mapPointLatitude]))]).intersectsCoordinate(fromLonLat([this.showPointPoint.longitude, this.showPointPoint.latitude]))) {          
            try {
              const data = await (await fetch(`https://router.project-osrm.org/route/v1/driving/${this.showPointPoint.longitude},${this.showPointPoint.latitude};${displayMap.mapCenterLongitude},${displayMap.mapCenterLatitude}?overview=full&alternatives=false&steps=false&annotations=duration,distance,speed`)).json();
              if (data.routes && data.routes.length > 0) {
                routeDistance = data.routes[0].distance;
                if (data.routes[0].legs && data.routes[0].legs[0].annotation && data.routes[0].legs[0].annotation.speed) trafficDuration = this.$displayFunctions.default.fromSecondsToHoursMinutes(Math.round(data.routes[0].legs[0].annotation.speed.reduce((total, speed, i) => speed > 0 ? total + (data.routes[0].legs[0].annotation.distance[i] / speed) : total, 0)));
                if (!this.navigation.routeVectorSource) {
                  this.navigation.routeVectorSource = new VectorSource();
                  this.navigation.routeVectorLayer = new VectorLayer({ source: this.navigation.routeVectorSource });
                  this.navigation.mapComponent.addLayer(this.navigation.routeVectorLayer);
                }
                this.navigation.routeVectorSource.clear();
                if (data.routes[0].legs && data.routes[0].legs[0].annotation && data.routes[0].legs[0].annotation.speed) {                
                  for (let i = 0; i < polyline.decode(data.routes[0].geometry).map(coord => fromLonLat([coord[1], coord[0]])).length - 1; i++) {
                    const segmentFeature = new Feature({'geometry': new LineString([polyline.decode(data.routes[0].geometry).map(coord => fromLonLat([coord[1], coord[0]]))[i], polyline.decode(data.routes[0].geometry).map(coord => fromLonLat([coord[1], coord[0]]))[i + 1]])});
                    segmentFeature.setStyle(new Style({'stroke': new Stroke({'color': (data.routes[0].legs[0].annotation.speed[i] || data.routes[0].legs[0].annotation.speed[data.routes[0].legs[0].annotation.speed.length - 1]) * 3.6 > 35 ? '#FF6666' : '#66B3FF', 'width': 3})}));
                    this.navigation.routeVectorSource.addFeature(segmentFeature);
                  }
                } else {
                  const routeFeature = new Feature({'geometry': new LineString(polyline.decode(data.routes[0].geometry).map(coord => fromLonLat([coord[1], coord[0]])))});
                  routeFeature.setStyle(new Style({'stroke': new Stroke({'color': '#A0A0A0', 'width': 3})}));
                  this.navigation.routeVectorSource.addFeature(routeFeature);
                }
                this.navigation.mapMainPointVectorLayer.setStyle(new Style({'image': new Icon({'src': 'https://maps.google.com/mapfiles/ms/icons/red-dot.png', 'scale': 1, 'anchor': [0.5, 1]}), 'text': new Text({'text': this.showPointName + '\n\n' + 'Tiempo estimado: ' + (trafficDuration || 'N/A') + '\n' + 'Distancia: ' + (routeDistance ? this.$displayFunctions.default.fromMetersToKilometers(routeDistance) : 'N/A'), 'offsetY': -90, 'font': 'bold 15px Arial', 'fill': new Fill({'color': '#000000'}), 'stroke': new Stroke({'color': '#ffffff', 'width': 3})})}));
                this.navigation.mapComponent.getView().fit(this.navigation.routeVectorSource.getExtent(), {'padding': [50, 50, 50, 50], 'maxZoom': 15});
              }
            } catch {
              console.error('Error');
            }
            break;
          }
        }
      },

      startCreationMap() {
        const polygonModify = new Modify({'source': this.navigation.mapMainPolygonVectorSource});
        polygonModify.on('modifystart', (event) => {
          if (!event.features.getArray()[0].get('name')) event.features.getArray()[0].set('originalCoordinates', event.features.getArray()[0].getGeometry().getCoordinates());
        });
        polygonModify.on('modifyend', (event) => {
          if (!event.features.getArray()[0].get('name')) {
            
            if (this.navigation.mapMainPolygonVectorSource.getFeatures().length > 0) {
              this.navigation.mapCreationPolygonCoordinates = this.navigation.mapMainPolygonVectorSource.getFeatures()[0].getGeometry().getCoordinates()[0].map(coord => transform(coord, 'EPSG:3857', 'EPSG:4326'));
              this.$emit('creationMapPolygonUpdate', {'creationMapPolygonCoordinates': this.navigation.mapCreationPolygonCoordinates});
            }
          }
        });
        this.navigation.mapComponent.addInteraction(polygonModify);
        const centerPointModify = new Modify({'source': this.navigation.mapMainPointVectorSource});
        centerPointModify.on('modifystart', (event) => {
          event.features.getArray()[0].set('originalCoordinates', event.features.getArray()[0].getGeometry().getCoordinates());
        });
        centerPointModify.on('modifyend', (event) => {
          this.$emit('creationMapPointUpdate', {'creationMapPointCoordinates': transform(event.features.getArray()[0].getGeometry().getCoordinates(), 'EPSG:3857', 'EPSG:4326')});
        });
        this.navigation.mapComponent.addInteraction(centerPointModify);
        this.navigation.mapComponent.on('pointermove', (event) => {
          if (!this.navigation.mapCreationHasPoint) {
            this.navigation.previewPointVectorSource.clear();
            this.navigation.previewPolygonVectorSource.clear();
            
            const previewFeature = new Feature({
              'geometry': new Point(event.coordinate),
              'name': this.creationMapName
            });
            this.navigation.previewPointVectorSource.addFeature(previewFeature);
            if (this.creationMapPolygon) {
              const previewPolygonFeature = new Feature({
                'geometry': new Polygon([[
                  [event.coordinate[0] - 750, event.coordinate[1] - 750],
                  [event.coordinate[0] + 750, event.coordinate[1] - 750],
                  [event.coordinate[0] + 750, event.coordinate[1] + 750],
                  [event.coordinate[0] - 750, event.coordinate[1] + 750],
                  [event.coordinate[0] - 750, event.coordinate[1] - 750]
                ]])
              });
              this.navigation.previewPolygonVectorSource.addFeature(previewPolygonFeature);
            }
          }
        });
        this.navigation.mapComponent.on('click', (event) => {
          if (!this.navigation.mapCreationHasPoint) {
            this.navigation.previewPointVectorSource.clear();
            this.navigation.previewPolygonVectorSource.clear();
            this.placeCreationMapPoint(event.coordinate);
          }
        });
      },

      placeCreationMapPoint(creationMapPointCoordinates) {
        if (this.creationMapPolygon && this.navigation.mapDisplayVectorSource.getFeatures().filter(feature => feature.getGeometry() instanceof Polygon).some(map => map.getGeometry().intersectsCoordinate(creationMapPointCoordinates))) {
          this.$root.notificationDialog.showNotificationDialog({
            'notificationDialogTitle': 'ERROR',
            'notificationDialogBody': 'El mapa no se puede crear, ya que el punto de creación no puede estar dentro del área de otro mapa existente',
            'notificationDialogColor': 'error',
            'notificationDialogIsPersistent': false
          });
          return;
        }
        if (this.creationMapPolygon && this.navigation.mapDisplayVectorSource.getFeatures().filter(feature => feature.getGeometry() instanceof Polygon).some(map => [[creationMapPointCoordinates[0] - 750, creationMapPointCoordinates[1] - 750], [creationMapPointCoordinates[0] + 750, creationMapPointCoordinates[1] - 750], [creationMapPointCoordinates[0] + 750, creationMapPointCoordinates[1] + 750], [creationMapPointCoordinates[0] - 750, creationMapPointCoordinates[1] + 750], [creationMapPointCoordinates[0] - 750, creationMapPointCoordinates[1] - 750]].some(creationMapPolygonCoordinate => map.getGeometry().intersectsCoordinate(creationMapPolygonCoordinate)) || map.getGeometry().getCoordinates()[0].some(creationMapPolygonCoordinate => new Polygon([[[creationMapPointCoordinates[0] - 750, creationMapPointCoordinates[1] - 750], [creationMapPointCoordinates[0] + 750, creationMapPointCoordinates[1] - 750], [creationMapPointCoordinates[0] + 750, creationMapPointCoordinates[1] + 750], [creationMapPointCoordinates[0] - 750, creationMapPointCoordinates[1] + 750], [creationMapPointCoordinates[0] - 750, creationMapPointCoordinates[1] - 750]]]).intersectsCoordinate(creationMapPolygonCoordinate)))) {
          this.$root.notificationDialog.showNotificationDialog({
            'notificationDialogTitle': 'ERROR',
            'notificationDialogBody': 'El mapa no se puede crear, ya que parte de su área se superpondría con el área de otro mapa existente',
            'notificationDialogColor': 'error',
            'notificationDialogIsPersistent': false
          });
          return;
        }
        if (this.navigation.mapMainPointVectorSource) this.navigation.mapMainPointVectorSource.clear();
        if (this.navigation.mapMainPolygonVectorSource) this.navigation.mapMainPolygonVectorSource.clear();
        this.navigation.mapMainPointVectorSource.addFeature(new Feature({'geometry': new Point(creationMapPointCoordinates), 'name': this.creationMapName}));
        this.navigation.mapCreationHasPoint = true;
        if (this.creationMapPolygon) {
          this.navigation.mapMainPolygonVectorSource.addFeature(new Feature({'geometry': new Polygon([[[creationMapPointCoordinates[0] - 750, creationMapPointCoordinates[1] - 750], [creationMapPointCoordinates[0] + 750, creationMapPointCoordinates[1] - 750], [creationMapPointCoordinates[0] + 750, creationMapPointCoordinates[1] + 750], [creationMapPointCoordinates[0] - 750, creationMapPointCoordinates[1] + 750], [creationMapPointCoordinates[0] - 750, creationMapPointCoordinates[1] - 750]]])}));
          this.$emit('creationMapPolygonUpdate', {'creationMapPolygonCoordinates': this.navigation.mapMainPolygonVectorSource.getFeatures()[0].getGeometry().getCoordinates()[0].map(coord => transform(coord, 'EPSG:3857', 'EPSG:4326'))});
        }
        this.$emit('creationMapPointUpdate', {'creationMapPointCoordinates': transform(creationMapPointCoordinates, 'EPSG:3857', 'EPSG:4326')});
      },

      drawEditMap() {
        if (!this.navigation.mapMainPointVectorSource || !this.editMapPoint || !this.editMapPoint.latitude || !this.editMapPoint.longitude) return;
        if (!this.navigation.mapMainPolygonVectorSource || !this.editMapPolygon || this.editMapPolygon.length == 0) return;
        this.navigation.mapMainPointVectorSource.clear();
        this.navigation.mapMainPolygonVectorSource.clear();
        this.navigation.mapMainPointVectorSource.addFeature(new Feature({'geometry': new Point(fromLonLat([this.editMapPoint.longitude, this.editMapPoint.latitude])), 'name': this.editMapName}));
        this.navigation.mapMainPointVectorLayer.setStyle(new Style({'image': new CircleStyle({'radius': 8, 'fill': new Fill({'color': this.editMapColor ? this.$generalFunctions.default.fromHexToRGBA(this.editMapColor, 1) : '#ffffff'}), 'stroke': new Stroke({'color': '#000000', 'width': 2})}), 'text': new Text({'text': this.editMapName, 'offsetY': -20, 'font': 'bold 15px Arial', 'stroke': new Stroke({'color': '#ffffff', 'width': 3})})}));
        this.navigation.mapComponent.getView().setCenter(fromLonLat([this.editMapPoint.longitude, this.editMapPoint.latitude]));
        this.navigation.mapMainPolygonVectorSource.addFeature(new Feature({'geometry': new Polygon([this.editMapPolygon.map(editMapPolygonPoint => fromLonLat([editMapPolygonPoint.longitude, editMapPolygonPoint.latitude]))])}));
        this.navigation.mapMainPolygonVectorLayer.setStyle(new Style({'fill': new Fill({'color': this.editMapColor ? this.$generalFunctions.default.fromHexToRGBA(this.editMapColor, 0.4) : '#ffffff'}), 'stroke': new Stroke({'color': '#000000', 'width': 2})}));
        this.navigation.mapComponent.getView().fit(this.navigation.mapMainPolygonVectorSource.getExtent(), {padding: [50, 50, 50, 50], maxZoom: 15});
        this.editMapDivisions.forEach(editMapDivision => {
          const editMapDivisionFeature = new Feature({'geometry': new Polygon([editMapDivision.mapDivisionPoints.map(mapDivisionPoint => fromLonLat([mapDivisionPoint.mapDivisionPointLongitude, mapDivisionPoint.mapDivisionPointLatitude]))]), 'id': editMapDivision.mapDivisionName, 'name': editMapDivision.mapDivisionName, 'description': editMapDivision.mapDivisionDescription, 'color': editMapDivision.mapDivisionColor});
          editMapDivisionFeature.setStyle(new Style({'stroke': new Stroke({'color': '#383838', 'width': 2, 'lineDash': [5, 5]}), 'fill': new Fill({'color': editMapDivision.mapDivisionColor ? this.$generalFunctions.default.fromHexToRGBA(editMapDivision.mapDivisionColor, 0.4) : 'rgba(0,0,0,0)'}), 'text': new Text({'text': editMapDivision.mapDivisionName + (editMapDivision.mapDivisionDescription ? '\n' + editMapDivision.mapDivisionDescription : ''), 'font': 'bold 10px Arial', 'stroke': new Stroke({'color': '#ffffff', 'width': 3})})}));
          this.navigation.divisionVectorSource.addFeature(editMapDivisionFeature);      
        });
        this.navigation.mapComponent.on('contextmenu', (event) => {
          event.preventDefault();
          let foundFeature = null;
          this.navigation.mapComponent.forEachFeatureAtPixel(event.pixel, (feature) => {
            foundFeature = feature;
            return true;
          });
          if (foundFeature && foundFeature.get('id')) {
            this.navigation.updateDivisionFeature = foundFeature;
            this.input.mapDivisionName = this.navigation.updateDivisionFeature.get('name');
            this.input.mapDivisionDescription = this.navigation.updateDivisionFeature.get('description');
            this.input.mapDivisionColor = this.navigation.updateDivisionFeature.get('color');
            this.navigation.updateDivisionDialogIsVisible = true;
          }
        });
      },

      startEditMap() {
        const polygonModify = new Modify({'source': this.navigation.mapMainPolygonVectorSource});
        polygonModify.on('modifystart', (event) => {
          if (!event.features.getArray()[0].get('name')) event.features.getArray()[0].set('originalCoordinates', event.features.getArray()[0].getGeometry().getCoordinates());
        });
        polygonModify.on('modifyend', (event) => {
          if (!event.features.getArray()[0].get('name')) {
            if (this.navigation.mapMainPolygonVectorSource.getFeatures().length > 0) {
              this.navigation.mapEditPolygonCoordinates = this.navigation.mapMainPolygonVectorSource.getFeatures()[0].getGeometry().getCoordinates()[0].map(coord => transform(coord, 'EPSG:3857', 'EPSG:4326'));
              console.log(this.navigation.mapEditPolygonCoordinates);
              this.$emit('editMapPolygonUpdate', {'editMapPolygonCoordinates': this.navigation.mapEditPolygonCoordinates});
            }
          }
        });
        this.navigation.mapComponent.addInteraction(polygonModify);
        const centerPointModify = new Modify({'source': this.navigation.mapMainPointVectorSource});
        centerPointModify.on('modifystart', (event) => {
          event.features.getArray()[0].set('originalCoordinates', event.features.getArray()[0].getGeometry().getCoordinates());
        });
        centerPointModify.on('modifyend', (event) => {
          this.$emit('editMapPointUpdate', {'editMapPointCoordinates': transform(event.features.getArray()[0].getGeometry().getCoordinates(), 'EPSG:3857', 'EPSG:4326')});
        });
        this.navigation.mapComponent.addInteraction(centerPointModify);
        this.navigation.mapComponent.on('contextmenu', (event) => {
          let foundFeature = null;
          this.navigation.mapComponent.forEachFeatureAtPixel(event.pixel, (feature) => {
            foundFeature = feature;
            return true;
          });
          if (foundFeature && foundFeature == this.navigation.mapMainPolygonVectorSource.getFeatures()[0]) {
            event.preventDefault();
            if (!this.navigation.mapMainPolygonVectorSource.getFeatures().find(mapMainPolygonVectorSourceFeature => mapMainPolygonVectorSourceFeature.getGeometry() instanceof Polygon)) return;
            this.navigation.createDivisionDialogCoordinate = event.coordinate;
            this.navigation.createDivisionDialogIsVisible = true;
            this.input.mapDivisionName = null;
            this.input.mapDivisionDescription = null;
            this.input.mapDivisionColor = '#00000000';
          } else if (foundFeature && foundFeature.get('id') && foundFeature.get('id').startsWith('division-')) {
            event.preventDefault();
            this.input.mapDivisionName = foundFeature.get('name');
            this.input.mapDivisionDescription = foundFeature.get('description');
            this.input.mapDivisionColor = foundFeature.get('color');
            this.navigation.updateDivisionFeature = foundFeature;
            this.navigation.updateDivisionDialogIsVisible = true;
          }
        });
        const divisionModifyInteraction = new Modify({ source: this.navigation.divisionVectorSource });
        this.navigation.mapComponent.addInteraction(divisionModifyInteraction);
        divisionModifyInteraction.on('modifystart', (event) => {
          if (event.features.getArray()[0] && event.features.getArray()[0].getGeometry()) event.features.getArray()[0].set('originalCoordinates', event.features.getArray()[0].getGeometry().getCoordinates());
        });
        divisionModifyInteraction.on('modifyend', (event) => {
          if (JSON.stringify(event.features.getArray()[0].get('originalCoordinates')) == JSON.stringify(event.features.getArray()[0].getGeometry().getCoordinates())) {
            event.features.getArray()[0].unset('originalCoordinates');
            return;
          }
          if (!this.navigation.mapMainPolygonVectorSource.getFeatures().find(mapMainPolygonVectorSourceFeature => mapMainPolygonVectorSourceFeature.getGeometry() instanceof Polygon)) return;
          event.features.getArray()[0].unset('originalCoordinates');
          let aux = [];
          event.features.getArray()[0].getGeometry().getCoordinates()[0].forEach((coordinate) => {
            let test = transform(coordinate, 'EPSG:3857', 'EPSG:4326');
            aux.push(
              {
                'CRMLocalityMapDivisionPointLatitude': test[1],
                'CRMLocalityMapDivisionPointLongitude': test[0]
              }
            )
          });
          console.log(aux);
          this.emitDivisionsUpdate();
        });
      },

      startCRMWhatsappInvoiceByCRMLocalityMapDivisionMap() {
        this.navigation.mapComponent.on('contextmenu', (event) => {
          let foundFeature = null;
          this.navigation.mapComponent.forEachFeatureAtPixel(event.pixel, (feature) => {
            foundFeature = feature;
            return true;
          });
          if (foundFeature && foundFeature.get('mapDivisionID')) {
            event.preventDefault();
            const mapDivisionID = foundFeature.get('mapDivisionID');
            this.$root.dialogComponent.openCRMWhatsappInvoicesDialog(this.date, 'null', false, null, null, this.CRMWhatsappInvoiceCRMLocalityID, mapDivisionID, null, null);
          }
        });
      },

      createDivision() {
        const divisionFeature = new Feature({geometry: new Polygon([[[this.navigation.createDivisionDialogCoordinate[0] - 100, this.navigation.createDivisionDialogCoordinate[1] - 100], [this.navigation.createDivisionDialogCoordinate[0] + 100, this.navigation.createDivisionDialogCoordinate[1] - 100], [this.navigation.createDivisionDialogCoordinate[0] + 100, this.navigation.createDivisionDialogCoordinate[1] + 100], [this.navigation.createDivisionDialogCoordinate[0] - 100, this.navigation.createDivisionDialogCoordinate[1] + 100], [this.navigation.createDivisionDialogCoordinate[0] - 100, this.navigation.createDivisionDialogCoordinate[1] - 100]]]), name: this.input.mapDivisionName, description: this.input.mapDivisionDescription, color: this.input.mapDivisionColor, id: `division-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`});
        divisionFeature.setStyle(new Style({ stroke: new Stroke({ 'color': '#383838', 'width': 2, 'lineDash': [5, 5] }), fill: new Fill({ 'color': this.$generalFunctions.default.fromHexToRGBA(this.input.mapDivisionColor, 0.4) }), 'text': new Text({ 'text': this.input.mapDivisionName + (this.input.mapDivisionDescription ? '\n' + this.input.mapDivisionDescription : ''), 'fill': new Fill({ color: '#383838' }), 'stroke': new Stroke({ 'color': '#fff', width: 3 }), textAlign: 'center', textBaseline: 'middle', font: '10px Arial' }) }));
        this.navigation.divisionVectorSource.addFeature(divisionFeature);
        this.navigation.createDivisionDialogIsVisible = false;
        this.input.mapDivisionName = null;
        this.input.mapDivisionDescription = null;
        this.input.mapDivisionColor = '#00000000';
        this.navigation.createDivisionDialogCoordinate = null;
        this.emitDivisionsUpdate();
      },

      deleteDivision() {
        if (this.navigation.updateDivisionFeature) this.navigation.divisionVectorSource.removeFeature(this.navigation.updateDivisionFeature);
        this.navigation.updateDivisionDialogIsVisible = false;
        this.input.mapDivisionName = null;
        this.navigation.updateDivisionFeature = null;
        this.emitDivisionsUpdate();
      },

      updateDivision() {
        if (!this.input.mapDivisionName || !this.navigation.updateDivisionFeature) return;
        this.navigation.updateDivisionFeature.set('name', this.input.mapDivisionName);
        this.navigation.updateDivisionFeature.set('description', this.input.mapDivisionDescription);
        this.navigation.updateDivisionFeature.set('color', this.input.mapDivisionColor);
        this.navigation.updateDivisionFeature.setStyle(new Style({ stroke: new Stroke({ color: '#383838', width: 2, lineDash: [5, 5] }), fill: new Fill({ color: this.$generalFunctions.default.fromHexToRGBA(this.input.mapDivisionColor, 0.4) }), text: new Text({ text: this.input.mapDivisionName + (this.input.mapDivisionDescription ? '\n' + this.input.mapDivisionDescription : ''), font: 'bold 10px Arial', fill: new Fill({ color: '#383838' }), stroke: new Stroke({ color: '#fff', width: 3 }) }) }));
        this.navigation.updateDivisionDialogIsVisible = false;
        this.input.mapDivisionName = null;
        this.input.mapDivisionDescription = null;
        this.input.mapDivisionColor = '#00000000';
        this.navigation.updateDivisionFeature = null;
        this.emitDivisionsUpdate();
      },

      validateDivisionInput(showNotification = true) {
        const regularExpressionChecker = /\S/;
        if (this.input.mapDivisionName && regularExpressionChecker.test(this.input.mapDivisionName)){
          if (this.input.mapDivisionName.length <= 30){
            if (this.input.mapDivisionDescription == null || this.input.mapDivisionDescription.length <= 100){
              if (this.input.mapDivisionColor){
                return {success: true, result: null};
              } else {
                if (showNotification){
                  this.$root.notificationDialog.showSystemNotificationDialog('insertOrDeleteCRMWhatsappContactCardStampDialog_warning', 'warning', 'El color de la división es obligatorio', null, false);
                }
                return {success: false, result: 'El color de la división es obligatorio'};
              }
            } else {
              if (showNotification){
                this.$root.notificationDialog.showSystemNotificationDialog('insertOrDeleteCRMWhatsappContactCardStampDialog_warning', 'warning', 'La descripción de la división no puede exceder los 100 caracteres de longitud', null, false);
              }
              return {success: false, result: 'La descripción de la división no puede exceder los 65535 caracteres de longitud'};
            }
          } else {
            if (showNotification){
              this.$root.notificationDialog.showSystemNotificationDialog('insertOrDeleteCRMWhatsappContactCardStampDialog_warning', 'warning', 'El nombre de la división no puede exceder los 30 caracteres de longitud', null, false);
            }
            return {success: false, result: 'El nombre de la división no puede exceder los 30 caracteres de longitud'};
          }
        } else {
          if (showNotification){
            this.$root.notificationDialog.showSystemNotificationDialog('insertOrDeleteCRMWhatsappContactCardStampDialog_warning', 'warning', 'El nombre de la división es obligatorio', null, false);
          }
          return {success: false, result: 'El nombre de la división es obligatorio'};
        }
      },
      
      isPointStrictlyInsidePolygon(point, polygon) {
        let inside = false;
        for (let i=0, j=polygon.length-1; i<polygon.length; j=i++) {
          if (((polygon[i][1] > point[1]) != (polygon[j][1] > point[1])) && (point[0] < (polygon[j][0] - polygon[i][0]) * (point[1] - polygon[i][1]) / (polygon[j][1] - polygon[i][1] + 1e-12) + polygon[i][0])) inside = !inside;
        }
        return inside;
      },

      doPolygonsIntersect(polygon1, polygon2) {
        for (let i = 0; i < polygon1.length - 1; i++) {
          for (let j = 0; j < polygon2.length - 1; j++) {
            if (((polygon2[j+1][1] - polygon1[i][1]) * (polygon2[j][0] - polygon1[i][0]) > (polygon2[j][1] - polygon1[i][1]) * (polygon2[j+1][0] - polygon1[i][0])) != ((polygon2[j+1][1] - polygon1[i+1][1]) * (polygon2[j][0] - polygon1[i+1][0]) > (polygon2[j][1] - polygon1[i+1][1]) * (polygon2[j+1][0] - polygon1[i+1][0])) && ((polygon1[i+1][1] - polygon1[i][1]) * (polygon2[j][0] - polygon1[i][0]) > (polygon2[j][1] - polygon1[i][1]) * (polygon1[i+1][0] - polygon1[i][0])) != ((polygon1[i+1][1] - polygon1[i][1]) * (polygon2[j+1][0] - polygon1[i][0]) > (polygon2[j+1][1] - polygon1[i][1]) * (polygon1[i+1][0] - polygon1[i][0]))) {
              return true;
            }
          }
        }
        if (polygon1.length > 2 && polygon2.length > 2) {
          if (polygon1.some(point => this.isPointStrictlyInsidePolygon(point, polygon2))) return true;
          if (polygon2.some(point => this.isPointStrictlyInsidePolygon(point, polygon1))) return true;
        }
        return false;
      },

      emitDivisionsUpdate() {
        if (this.creationMap) {
          this.$emit('creationMapDivisionsUpdate', {'creationMapDivisions': this.navigation.divisionVectorSource.getFeatures().map(division => ({'divisionName': division.get('name'), 'divisionDescription': division.get('description'), 'divisionColor': division.get('color'), 'divisionPoints': division.getGeometry().getCoordinates()[0].map(divisionCoordinates => [transform(divisionCoordinates, 'EPSG:3857', 'EPSG:4326')[0], transform(divisionCoordinates, 'EPSG:3857', 'EPSG:4326')[1]])}))});
        } else if (this.editMap) {
          this.$emit('editMapDivisionsUpdate', {'editMapDivisions': this.navigation.divisionVectorSource.getFeatures().map(division => ({'divisionName': division.get('name'), 'divisionDescription': division.get('description'), 'divisionColor': division.get('color'), 'divisionPoints': division.getGeometry().getCoordinates()[0].map(divisionCoordinates => [transform(divisionCoordinates, 'EPSG:3857', 'EPSG:4326')[0], transform(divisionCoordinates, 'EPSG:3857', 'EPSG:4326')[1]])}))});
        }
      }
    },

    mounted() {
      this.createMapMainComponent();
      this.createDisplayMaps();
      if (this.creationMap){
        this.startCreationMap();
      }
      if (this.showMap){
        this.drawShowMap();
      }
      if (this.showPoint){
        this.drawShowPoint();
      }
      if (this.showRoute){
        this.drawShowRoute();
      }
      if (this.editMap){
        this.drawEditMap();
        this.startEditMap();
      }
      if (this.drawCRMWhatsappInvoiceByCRMLocalityMapDivision){
        this.startCRMWhatsappInvoiceByCRMLocalityMapDivisionMap();
      }
    }
  };
</script>